import { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { useAuth } from "../firebase-config";
import { cachedFetch, TTL } from "./clientCache";

// Loads the signed-in user's full transaction history once, served from the
// client cache when fresh to avoid re-reading Firestore on every page load.
// Firestore rules allow users to read their own userdata subcollections,
// so this avoids a Cloud Function round-trip.
export function useTransactions() {
  const user = useAuth();
  const [transactions, setTransactions] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    cachedFetch("transactions", TTL.TRANSACTIONS, async () => {
      const snap = await getDocs(collection(getFirestore(), "userdata", user.uid, "transactions"));
      return snap.docs.map((d) => d.data());
    })
      .then((txs) => {
        if (!cancelled) setTransactions(txs);
      })
      .catch((err) => {
        console.error("Failed to load transactions:", err);
        if (!cancelled) setError(err);
      });
    return () => { cancelled = true; };
  }, [user]);

  return { transactions, error, loading: transactions === null && !error };
}
